import React, { useEffect } from "react";


const ThankYou = () => {
    useEffect(() => {
        // Load the tracker script
        const script = document.createElement("script");
        // script.src = "/tracker.js";
        script.src = 'https://www.infuber.com/tracker.js'; // Link to your hosted tracker.js file
        // script.src = 'https://infuber.vercel.app/tracker.js';
        script.async = true;
        script.crossOrigin = "anonymous";
        script.onload = () => {
        //   console.log("✅ Tracker script loaded successfully");
        };
        script.onerror = (error) => {
          console.error("❌ Failed to load tracker script:", error);
        };

        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center w-full max-w-lg">
                <div className="mb-6">
                    <img
                        src="/success.jpeg"
                        alt="Success"
                        className="w-20 h-20 mx-auto mb-4"
                    />
                    <h2 className="text-2xl font-bold text-gray-800">
                        Thank You for Your Purchase!
                    </h2>
                    <p className="text-gray-600 mt-2">
                        Your order has been successfully processed.
                    </p>
                </div>

                <div className="mt-8 space-y-4">
                    <button 
                        onClick={() => window.location.href = '/'}
                        className="w-full bg-orange-500 text-white py-3 px-6 rounded-lg hover:bg-orange-600 transition duration-200"
                    >
                        Return to Homepage
                    </button>
                </div>

                <div className="mt-8 border-t pt-6">
                    <p className="text-sm text-gray-500">
                        Need help? 
                        <a href="/contact" className="text-orange-500 hover:text-orange-600 ml-1">
                            Contact Support
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
